import React from 'react';

import asArray from 'utils/arrays/asArray.util';

import RadioButton from 'onboarding/common/RadioButton';

const RadioForm = ({ onChange, selections }) => (
  <ul data-bem="RadioForm" className="cfix">
    {asArray(selections).map((selection) => (
      <RadioButton id={selection.id} label={selection.label} name={selection.name} checked={selection.checked} key={selection.id} onChange={onChange} />
    ))}
  </ul>
);

export default RadioForm;
